Vue.component('my-tab', {
    template: '#tab',
    delimiters: ['[[', ']]'],
    data: function() {
        return {
            active: false
        };
    },
    props: {
		    'next': {
			    required: false,
			    type: String,
			    default: null
		    },
        'title': {
            required: true,
            type: String
        },
        'name': {
            required: true,
            type: String
        },
        'button': {
            required: true,
            type: String
        },
        'isActive': {
            required: false,
            type: Boolean,
            default: false
        }
    },
    methods: {
        goToTab: function(next) {
            var active_tab = false;
            this.$parent.tabs.forEach(function(value) {
                if (value.$options.propsData.name === next) {
                    active_tab = value;
                    value.active = true;
                    window.scrollTo(0,0);
                } else {
                    value.active = false;
                }
            });
            this.$parent.current = active_tab;
        }
    },
    created: function() {
        this.active = this.isActive;
    },
    mounted: function() {
        this.$parent.addTab(this);
    },
    watch: {
        //isActive: function(){}
    }
});
